import {
  BrochureCount,
  BrochurePaper,
  BrochureSide
} from '~/tenants/bre/performable/print/brochures/BreBrochuresConfig';

type CountMap = Record<BrochureCount, string>;

type PaperMap = Record<BrochurePaper, CountMap>;

type SideMap = Record<BrochureSide, Partial<PaperMap>>;

export const BreBrochuresRate: SideMap = {
    8: {
      low_gloss: {
        50: '550',
        100: '685',
        150: '765',
        200: '940',
      },
      heavy_gloss: {
        50: '585',
        100: '730',
        150: '880',
        200: '995',
      },
    },
    12: {
      low_gloss: {
        50: '645',
        100: '780',
        150: '1025',
        200: '1255',
      },
    },
    16: {
      low_gloss: {
        50: '705',
        100: '950',
        150: '1240',
        200: '1470',
      },
    },
    20: {
      low_gloss: {
        50: '875',
        100: '1220',
        150: '1610',
        200: '1975',
      },
    },
    24: {
      low_gloss: {
        50: '1010',
        100: '1415',
        150: '1880',
        200: '2055',
      },
    },
    28: {
      low_gloss: {
        50: '1140',
        100: '1610',
        150: '1940',
        200: '2535',
      },
    },
    32: {
      low_gloss: {
        50: '1270',
        100: '1815',
        150: '2415',
        200: '2990',
      },
    }
};

export const BreBrochuresPay: SideMap = {
  8: {
    low_gloss: {
      50: '475',
      100: '595',
      150: '665',
      200: '815',
    },
    heavy_gloss: {
      50: '510',
      100: '635',
      150: '765',
      200: '875',
    },
  },
  12: {
    low_gloss: {
      50: '560',
      100: '675',
      150: '890',
      200: '1090',
    },
  },
  16: {
    low_gloss: {
      50: '610',
      100: '825',
      150: '1075',
      200: '1275',
    },
  },
  20: {
    low_gloss: {
      50: '760',
      100: '1060',
      150: '1400',
      200: '1715',
    },
  },
  24: {
    low_gloss: {
      50: '875',
      100: '1230',
      150: '1635',
      200: '1785',
    },
  },
  28: {
    low_gloss: {
      50: '990',
      100: '1400',
      150: '1865',
      200: '2205',
    },
  },
  32: {
    low_gloss: {
      50: '1105',
      100: '1575',
      150: '2100',
      200: '2600',
    },
  }
};
